import axios from '@util/axios'

export const LincolnNewGlobalUMRService = {
  list: (company_id, params = {}, options = {}) =>
    axios({
      ...options,
      url: '/lincoln/new-global-umr/list/',
      params: {
        ...params,
        company_id
      }
    }),
  check: (company_id, options = {}) =>
    axios({
      ...options,
      url: '/lincoln/new-global-umr/check/',
      method: 'POST',
      data: {
        company_id
      }
    }),

  getBdxDataRows: (data = {}) =>
    axios({
      url: '/bdx/datarows/',
      method: 'POST',
      data
    })
}
